/*
  Tatagaltier homepage hero — crossfade slideshow (calaqisya-style).

  Slides are stacked; the active one is opacity:1, others opacity:0 (CSS handles
  the fade). No horizontal scroll, clones, or parallax. Supports autoplay
  (pause on hover/focus + pause button), dots, arrows, keyboard, and
  swipe/drag-to-advance. Loops by wrapping the index.
*/
(function () {
  var SWIPE_MIN = 40; // px before a drag counts as a swipe

  function init(root) {
    if (root.dataset.heroReady) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var n = slides.length;
    if (!n) return;
    root.dataset.heroReady = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var autoplayBtn = root.querySelector('[data-hero-autoplay]');
    var wantAutoplay = root.dataset.autoplay === 'true';
    var speed = (parseFloat(root.dataset.speed) || 6) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var current = -1;
    function show(i) {
      i = ((i % n) + n) % n;
      slides.forEach(function (s, idx) {
        var on = idx === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', on ? '0' : '-1');
        });
      });
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      current = i;
    }
    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    // ---- autoplay ----
    var timer = null;
    var userPaused = false;
    function setBtn(playing) {
      if (!autoplayBtn) return;
      autoplayBtn.classList.toggle('is-paused', !playing);
      autoplayBtn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
    }
    function play() {
      if (!wantAutoplay || reduce.matches || userPaused || n < 2) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
      setBtn(true);
    }
    function haltTimer() { clearInterval(timer); timer = null; }
    function pause() { haltTimer(); setBtn(false); }
    function restart() { if (timer !== null) { clearInterval(timer); timer = setInterval(next, speed); } }

    // ---- controls ----
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); restart(); });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function (e) { e.preventDefault(); show(idx); restart(); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); restart(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); restart(); }
    });
    if (autoplayBtn) {
      autoplayBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        if (userPaused) pause(); else play();
      });
    }

    // Pause on hover/focus; resume on leave (unless the user explicitly paused).
    root.addEventListener('mouseenter', function () { if (wantAutoplay) haltTimer(); });
    root.addEventListener('mouseleave', function () { if (wantAutoplay && !userPaused) play(); });
    root.addEventListener('focusin', function () { if (wantAutoplay) haltTimer(); });
    root.addEventListener('focusout', function (e) { if (wantAutoplay && !userPaused && !root.contains(e.relatedTarget)) play(); });
    reduce.addEventListener('change', function () { if (reduce.matches) pause(); else play(); });

    // ---- drag + click-zone navigation (calaqisya-style) ----
    // Drag/swipe horizontally to change slides; a plain click on the left half
    // goes to the previous slide and the right half to the next — while the CTA,
    // dots, links and controls keep their own behaviour. Left/right halves also
    // get a directional cursor.
    var stage = root.querySelector('[data-hero-track]') || root;
    var startX = null, startY = null, startTarget = null;
    function isInteractive(el) {
      return el && el.closest && el.closest('a, button, [data-hero-dot], .tata-hero-slider__controls, .tata-hero-slide__cta-wrap');
    }
    function slideLinkFor(el) {
      var slide = el && el.closest && el.closest('[data-hero-slide]');
      return slide && slide.getAttribute('data-hero-slide-link');
    }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX; startY = e.clientY; startTarget = e.target;
    });
    stage.addEventListener('pointerup', function (e) {
      if (startX == null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      var adx = Math.abs(dx), ady = Math.abs(dy);
      var downTarget = startTarget;
      startX = null;
      // Drag/swipe (clear horizontal intent) -> change slide, either direction.
      if (adx > SWIPE_MIN && adx > ady) {
        if (dx < 0) next(); else prev();
        restart();
        return;
      }
      // Ignore vertical scrolls / ambiguous drags — only a genuine click/tap
      // (little movement in both axes) does anything below.
      if (adx > 8 || ady > 8) return;
      if (isInteractive(downTarget) || isInteractive(e.target)) return;
      // Whole-slide link: a plain click navigates to it (mouse/touch).
      var link = slideLinkFor(e.target) || slideLinkFor(downTarget);
      if (link) { window.location.href = link; return; }
      // Otherwise: left half = prev, right half = next.
      var rect = stage.getBoundingClientRect();
      if (e.clientX < rect.left + rect.width / 2) prev(); else next();
      restart();
    });
    stage.addEventListener('pointercancel', function () { startX = null; });
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Directional cursor over the left/right halves (default over the CTA etc.).
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (isInteractive(e.target)) { stage.classList.remove('is-zone-prev', 'is-zone-next'); return; }
      var rect = stage.getBoundingClientRect();
      var left = e.clientX < rect.left + rect.width / 2;
      stage.classList.toggle('is-zone-prev', left);
      stage.classList.toggle('is-zone-next', !left);
    });
    stage.addEventListener('pointerleave', function () { stage.classList.remove('is-zone-prev', 'is-zone-next'); });

    show(0);
    play();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hero-slider]').forEach(init);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
